import React from 'react'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useAuth} from '../../../../../app/modules/auth/core/Auth'

const SidebarMenuIncome = () => {
  const intl = useIntl()
  const {can} = useAuth()

  const incomeViewPerms = [
    'accounting_income_overview_view',
    'accounting_quotation_view',
    'accounting_deposit_receipt_view',
    'accounting_invoice_view',
    'accounting_receipt_view',
    'accounting_sales_tax_invoice_view',
    'accounting_credit_note_view',
    'accounting_debit_note_view',
    'accounting_billing_note_view',
  ]

  return (
    <>
      {can(incomeViewPerms) && (
        <SidebarMenuItemWithSub
          to={'/revenue'}
          title={'รายรับ'}
          icon='file-down'
        >
          {can('accounting_income_overview_view') && (
            <SidebarMenuItem
              to='/revenue-dashboard'
              icon='chart'
              title={'ภาพรวมรายรับ'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_quotation_view') && (
            <SidebarMenuItem
              to='/quotation'
              icon='document'
              title={'ใบเสนอราคา'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_deposit_receipt_view') && (
            <SidebarMenuItem
              to='/deposit-receipt'
              icon='document'
              title={'ใบรับเงินมัดจำ'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_invoice_view') && (
            <SidebarMenuItem
              to='/invoice'
              icon='document'
              title={'ใบแจ้งหนี้'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_receipt_view') && (
            <SidebarMenuItem
              to='/revenue-receipt'
              icon='document'
              title={'ใบเสร็จรับเงิน'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_sales_tax_invoice_view') && (
            <SidebarMenuItem
              to='/revenue-tax-invoice'
              icon='document'
              title={'ใบกำกับภาษีขาย'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_credit_note_view') && (
            <SidebarMenuItem
              to='/revenue-credit-note'
              icon='document'
              title={'ใบลดหนี้'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_debit_note_view') && (
            <SidebarMenuItem
              to='/revenue-debit-note'
              icon='document'
              title={'ใบเพิ่มหนี้'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_billing_note_view') && (
            <SidebarMenuItem
              to='/revenue-billing-note'
              icon='document'
              title={'ใบวางบิล'}
              fontIcon='bi-app-indicator'
            />
          )}
        </SidebarMenuItemWithSub>
      )}
    </>
  )
}

export default SidebarMenuIncome
